import React, { Component } from 'react'

export default class Description extends Component {
    render() {
        return (
            <div>
                <section class="features" id="about">
                    <div class="container mt-5">
                        <div class="row justify-content-center">
                            <div class="col-lg-12">
                                <div class="text-center">
                                    <h6 class="text-gradiant fw-bold"></h6>
                                    <br />
                                    <h1 class="fw-bold">A New Place To Collect And Connect NFT Across.</h1>
                                    {/* <div class="d-flex align-items-center mt-4">
                                <button class="btn btn-primary">Explore Now</button>
                                <button class="btn btn-outline-dark ms-4">Create Account</button>
                            </div> */}
                                    <br /> <br />
                                    <h6 className='text-white'>
                                        NOTs is focused on creating NFTs that bring lasting value and support the Cosmosverse.
                                        To make this happen, NOTs made owning NFTs and staking on chains mutually beneficial.  Owning our feature NFT series, NOTs, provides a commission discount to stakers using NOTs.Art validator.  Each NOT has rarity tied to a commission discount, ranging from 5-25%.  NOTs are also backed by 1 token from that chain, so the NFT always has value. Staking on NOTs.Art is rewarded with PixelNot airdrops.  Incredible pixelated NOTs that feature IBC chains.
                                        PixelNots don’t have the token backing or staking discount, but they are a limited series that is also sold on Stargaze.
                                    </h6>
                                    <br /> <br />
                                    <h6 className='text-white'>
                                        NOTs is focused on creating NFTs that bring lasting value and support the Cosmosverse.  To make this happen, NOTs made owning NFTs and staking on chains mutually beneficial.  Owning our feature NFT series, NOTs, provides a commission discount to stakers using NOTs.Art validator.  Each NOT has rarity tied to a commission discount, ranging from 5-25%.  NOTs are also backed by 1 token from that chain, so the NFT always has value. Staking on NOTs.Art is rewarded with PixelNot airdrops.  Incredible pixelated NOTs that feature IBC chains.
                                        PixelNots don’t have the token backing or staking discount, but they are a limited series that is also sold on Stargaze.
                                    </h6>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="container mt-5">
                    <div class="row justify-content-center">
                        <div class="col-lg-4">
                            <div class="text-center card p-4 bg-gradient">

                                {/* <h1 class="fw-bold">A New Place To Collect And Connect NFT Across.</h1> */}
                                <div class="d-flex align-items-center mt-4">
                                    <button class="btn btn-primary">NOTs</button>
                                </div>
                                <br /> <br />
                                <p className='text-white'>
                            1 NOT   =   7% commission discount 
                            </p>
                            <p className='text-white'>
                            2 NOTs = 15% commission discount 
                            </p>
                            <p className='text-white'>
                            3 NOTs = 25% commission discount
                            </p>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="text-center card p-4 bg-gradient">

                                {/* <h1 class="fw-bold">A New Place To Collect And Connect NFT Across.</h1> */}
                                <div class="d-flex align-items-center mt-4">
                                    <button class="btn btn-primary">PixelNOTs</button>
                                </div>
                                <br /> <br />
                                <p className='text-white'>
                                    100% drop to stakers on Nots.Art
                                </p>
                                <p className='text-white'>
                                    +20% sold on market
                                </p>
                                <p className='text-white'>
                                    + 5% reserved for Giveaways
                                </p>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="text-center card p-4 bg-gradient">

                                {/* <h1 class="fw-bold">A New Place To Collect And Connect NFT Across.</h1> */}
                                <div class="d-flex align-items-center mt-4">
                                    <button class="btn btn-primary">Nots.Art Stakers</button>
                                </div>
                                <br /> <br />
                                <p className='text-white'>
                                    stakers are eligible for PixelNot airdrops
                                </p>
                                <p className='text-white'>stakers are eligible for Giveaways </p>
                            </div>
                        </div>
                    </div>
                </div>

                <section class="section" id="collection">
                    <div class="container">
                        <div class="row ">
                            <div class="col-lg-5">
                                <h6 class="text-gradiant fw-bold">NOTs Promise</h6>
                                <h4 class="fw-bold"> - No Whitelist</h4>
                                <h4 class="fw-bold"> - No handouts to influencers or celebrities </h4>
                                <h4 class="fw-bold"> - No backdoor deals</h4>
                            </div>
                            <div class="col-lg-7">
                                <div class="row">
                                    <h6 class="mb-2 fw-bold">NOTs will always</h6>
                                    <div class="col mt-4">
                                        <div class="service-box">
                                            <div class="content">
                                                <p>Treat all CosmosNots fairly and equally; no one is more important because of status or fame</p>
                                            </div>
                                        </div>
                                        <div class="service-box mt-5">
                                            <div class="content">
                                                <p>strive to give excellent customer service, including responding to customer questions in a timely fashion </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col mt-4">
                                        <div class="service-box">
                                            <div class="content">
                                                <p>Give Back to the Community through Giveaways and Utility based incentives</p>
                                            </div>
                                        </div>
                                        <div class="service-box mt-5">
                                            <div class="content">
                                               
                                                <p>Use our services for the betterment of all IBC chains</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



            </div>
        )
    }
}
